import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { mobileBreakpoint } from 'shared/constants/styles'

export const BigTooltipBody = styled.div(
  (props: { padding: string }) => css`
    position: relative;
    padding: ${props.padding};
    border-radius: 15px;
    background-color: #ffffff;
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.25);
    max-width: 490px;

    @media screen and (max-width: ${mobileBreakpoint}px) {
      padding: 1em 1em;
      width: 300px;
    }
  `
)

export const HeaderWrapper = styled.div`
  margin-bottom: 0.5em;
`

export const TooltipContent = styled.div`
  margin: 1.5em 0;
  @media screen and (max-width: ${mobileBreakpoint}px) {
    margin: 0;
    margin-bottom: 1em;
  }
`

export const TooltipFooter = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1em;
`

export const CloseWrapper = styled.div`
  position: absolute;
  top: 1em;
  right: 1em;

  button:focus {
    outline: 1px dotted #212121;
    outline: 5px auto -webkit-focus-ring-color;
  }
`
